var cms = {

	init: function () {
		this.firstLoad = true

		if (this.firstLoad) {
			this.getUIElements()
			this.addEventListeners()
			this.firstLoad = false
			this.activeDropdown = null
			// this.disableTab()
		}
	},

	getUIElements: function () {
		this.body = document.querySelector('body')
	},

	addEventListeners: function () {
		this.body.addEventListener('click', this.globalClickHandler.bind(this))
	},

	globalClickHandler: function (e) {
		var target = e.target
		var classList = target.classList
		var tabBtn = target.getAttribute('data-tab-btn')
		var dropdown = target.closest('.dropdown')
		var dropdownTrue = false
		if (dropdown) dropdownTrue = true

		switch (true) {
			case classList.contains('btn-switch:not([data-toggle-lang]'):
				classList.toggle('active')
				break
			case classList.contains('btn-multi-switch'):
				this.multiSwitchToggle(target, classList)
				break
			case dropdownTrue:
				this.toggleDropdown(target, dropdown)
				break
			case classList.contains('btn-delete-confirm') || classList.contains('btn-user-switch'):
				this.bubbleToggle(target)
				break
			case classList.contains('btn-bubble-delete') || classList.contains('btn-bubble-cancel'):
				e.preventDefault()
				this.closeBubble(target)
				break
			case tabBtn !== null:
				e.preventDefault()
				this.toggleTabs(target, tabBtn)
				break
			case classList.contains('btn-reference-toggle'):
				e.preventDefault()
				this.editableReferencesToggle(target)
				break
			case classList.contains('btn-collapse-individual'):
				e.preventDefault()
				this.individualEditableReferenceToggle(target)
				break
			default:
				this.closeActiveDropdowns(dropdown)
				this.activeDropdown = null
		}
	},

	multiSwitchToggle: function (target, classList) {
		var input = target.querySelector('input')
		if (classList.contains('active-step1')) {
			classList.remove('active-step1')
			classList.add('active-step2')
			input.value = 3
		} else if (classList.contains('active-step2')) {
			classList.remove('active-step1')
			classList.remove('active-step2')
			input.value = 1
		} else {
			classList.add('active-step1')
			input.value = 2
		}
	},

	closeActiveDropdowns: function (target) {
		var activeDropdowns = document.querySelectorAll('.dropdown.open')
		for (var i = activeDropdowns.length - 1; i >= 0; i--) {
			if (target === activeDropdowns[i]) continue
			activeDropdowns[i].classList.remove('open')
		}
	},

	toggleDropdown: function (target, dropdown) {
		// check if target is first child of dropdown
		var firstChild = false
		if (dropdown.firstChild === target) firstChild = true

		if (dropdown === this.activeDropdown && !firstChild) return
		this.closeActiveDropdowns(dropdown)

		if (dropdown.classList.contains('open')) {
			dropdown.classList.remove('open')
		} else {
			dropdown.classList.add('open')
			this.activeDropdown = dropdown
		}
	},

	bubbleToggle: function (target) {
		var buttonPosition = target.getBoundingClientRect()
		var recordID = target.getAttribute('id')

		// find bubble
		var btnClass = target.className.split(' ')[0]
		var bubbleClass = 'bubble' + btnClass.split('btn')[1]
		var bubble = document.querySelector('.' + bubbleClass)

		if (bubble) {
			// find delete btn in bubble
			var deleteBtn = bubble.querySelector('.btn-bubble-delete')
			deleteBtn.setAttribute('data-id', recordID)

			// bubble dimensions
			var bubbleDimensions = bubble.getBoundingClientRect()
			bubble.style.top = buttonPosition.top - (bubbleDimensions.height / 2) + 20 + 'px'
			bubble.style.left = buttonPosition.left - bubbleDimensions.width - 10 + 'px'
		}
	},

	closeBubble: function (target) {
		var bubble = target.parentNode
		bubble.style.top = '-400px'
	},

	setLanguagesDimensions (languages) {
		// find amount of actives languages
		var activeInt = 0
		for (var key in languages) {
			if (languages[key].active) activeInt++
		}

		// TO FIX: performance is really shit because of all the loops
		var languagesWrapper = document.querySelector('#multilanguage > .languages')
		var syncedFields = document.querySelectorAll('#multilanguage .sync')

		if (!languagesWrapper) return

		languagesWrapper.style.minWidth = activeInt * 600 + 'px'

		for (var s = syncedFields.length - 1; s >= 0; s--) {
			if (activeInt === 0) activeInt = 1
			syncedFields[s].style.maxWidth = activeInt * 600 + 'px'
		}

		for (var key1 in languages) {
			var lang = languages[key1].locale

			var elements = document.querySelectorAll('#multilanguage .lang.' + lang)

			if (languages[key1].active) {
				for (var e = elements.length - 1; e >= 0; e--) {
					// find form element and set tab index to -1 if it is disabled
					var formElements1 = elements[e].querySelectorAll('input:not([type=\'submit\']), textarea, select, div.redactor-styles')
					elements[e].classList.remove('disabled')

					// set publish state to 3 when auto publish is true and the instance does not exist yet
					if (elements[e].classList.contains('status-checkbox')) {
						const btnMultiSwitch = elements[e].querySelector('.btn-multi-switch')
						const publishInput = btnMultiSwitch.querySelector('input')
						const autopublish = btnMultiSwitch.getAttribute('data-autopublish')

						// find out if this is a new or an existing instance
						const locale = languages[key1].locale
						const instanceID = document.querySelector(`input[type="hidden"][name="lang.${locale}.id"]`).value

						if (instanceID === '0' && autopublish === 'true') {
							publishInput.value = 3
							btnMultiSwitch.classList.remove('active-step1')
							btnMultiSwitch.classList.add('active-step2')
						}
					}

					for (var fe = formElements1.length - 1; fe >= 0; fe--) {
						formElements1[fe].removeAttribute('tabindex')
					}
				}
			} else {
				for (var el = elements.length - 1; el >= 0; el--) {
					// find form element and set tab index to -1 if it is disabled
					var formElements2 = elements[el].querySelectorAll('input:not([type=\'submit\']), textarea, select, div.redactor-styles')
					elements[el].classList.add('disabled')

					// set publish state to 1 when auto publish is true and the instance does not exist yet
					if (elements[el].classList.contains('status-checkbox')) {
						const btnMultiSwitch = elements[el].querySelector('.btn-multi-switch')
						const publishInput = btnMultiSwitch.querySelector('input')
						const autopublish = btnMultiSwitch.getAttribute('data-autopublish')

						// find out if this is a new or an existing instance
						const locale = languages[key1].locale
						const instanceID = document.querySelector(`input[type="hidden"][name="lang.${locale}.id"]`).value

						if (instanceID === '0' && autopublish === 'true') {
							publishInput.value = 1
							btnMultiSwitch.classList.remove('active-step2')
						}
					}

					for (var fe1 = formElements2.length - 1; fe1 >= 0; fe1--) {
						formElements2[fe1].setAttribute('tabindex', '-1')
					}
				}
			}
		}
	},

	toggleTabs: function (target, tabBtn) {
		var tabGroup = target.getAttribute('data-tab-group')
		var tabBody = tabBtn
		var active = target.classList.contains('active')

		// find all tab buttons for this tab group
		var tabBtns = document.querySelectorAll('[data-tab-btn][data-tab-group="' + tabGroup + '"]')

		for (var i = tabBtns.length - 1; i >= 0; i--) {
			tabBtns[i].classList.remove('active')

			if (i === 0) {
				if (active) {
					target.classList.remove('active')
					this.closeTabBody(tabGroup)
				} else {
					target.classList.add('active')
					this.openTabBody(tabBody)
				}
			}
		}
	},

	openTabBody: function (tabGroup) {
		var tabGroups = document.querySelectorAll('[data-tab-body]')
		for (var i = tabGroups.length - 1; i >= 0; i--) {
			if (tabGroups[i].getAttribute('data-tab-body') === tabGroup) {
				tabGroups[i].style.display = 'block'
			} else {
				tabGroups[i].style.display = 'none'
			}
		}
	},

	closeTabBody: function (tabGroup) {
		var tabs = document.querySelectorAll('div[data-tab-group=' + tabGroup + ']')
		for (var i = tabs.length - 1; i >= 0; i--) {
			tabs[i].style.display = 'none'
		}
	},

	editableReferencesToggle: function (target) {
		var container = target.parentNode.parentNode
		var active = target.classList.contains('active')
		if (active) target.classList.remove('active')
		if (!active) target.classList.add('active')
		var editableReferences = container.querySelectorAll('.editable-reference-item')
		for (var i = editableReferences.length - 1; i >= 0; i--) {
			if (active) {
				editableReferences[i].classList.remove('collapsed')
			} else {
				editableReferences[i].classList.add('collapsed')
			}
		}
	},

	individualEditableReferenceToggle: function (target) {
		var container = target.parentNode
		if (container.classList.contains('collapsed')) {
			container.classList.remove('collapsed')
		} else {
			container.classList.add('collapsed')
		}
	},

	disableTab: function () {
		document.onkeydown = function (t) {
			if (t.which == 9) {
				return false
			}
		}
	}
}

export default cms
